import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles!.sharingStatus!.statusText = {
    css: css`
        padding-right: 30px;
        > div[class^="TooltipWrapper"] {
            div: last-child {
                left: 80px;
                div: last-child {
                    &::after {
                        content: "";
                        position: absolute;
                        top: 100%;
                        left: 20%;
                        margin-left: -6px;
                        border-width: 6px;
                        border-style: solid;
                        border-color: ${getColor("common.backgroundContrast")} transparent transparent transparent;
                    }
                }
            }
        }
    `,
};

// productListLineStyles

productListLineStyles.deleteLink = {
    typographyProps: { size: 12 },
    css: css`
        margin-top: 10px;
        & span {
            color: #e64e25 !important;
        }
    `,
};

productListLineStyles.uomGridItem = {
    width: 9,
    printWidth: 6,
    css: css`
        padding: 0px 20px 10px;
    `,
};
